export default "__VITE_ASSET__DsbdJ50n__"